module.exports = __webpack_public_path__ + "img/med-experience-dark.ecfb6bff.svg";